import {
  AfterViewInit,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import { GenericComponent } from "../../components/generic.component";
import { AlertDTO, AlertRange } from "../../models/alert-dto";
import { HelperService } from "../../../core/services/helper.service";
import { ClientDTO } from "../../models/client-dto";
import { AlertService } from "../../../core/services/alert.service";
import { take } from "rxjs/operators";

@Component({
    selector: "app-smartfleet-accordion-search",
    templateUrl: "./accordion-search.component.html",
    styleUrls: ["./accordion-search.component.scss"],
    standalone: false
})
export class AccordionSearchComponent
  extends GenericComponent
  implements OnChanges, OnInit, AfterViewInit
{
  @Output() selectedItem: any = new EventEmitter<ClientDTO>();
  panelOpenStateToday = false;
  panelOpenStateYestarday = false;
  panelOpenStateWeek = false;
  panelOpenStateOlder = false;
  searchForm = this.fb.group({
    content: [""],
    type: ["ALL"]
  });

  @Input() titleSearch: string;
  @Input() arrayAccordion: AlertRange;
  @Input() arrayAccordionUnsorted: Array<AlertDTO>;
  filteredArray = new Array<AlertDTO>();
  arrayAccordionUnfiltered: AlertRange;
  arrayAccordionUnsortedUnFiltered: Array<AlertDTO>;
  search: string;

  constructor(
    public helperService: HelperService,
    private alertsService: AlertService,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit() {
    this.searchForm.valueChanges.subscribe((search) => {
      this.searchCtrl();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.arrayAccordionUnsortedUnFiltered = this.arrayAccordionUnsorted;
    this.arrayAccordionUnfiltered = this.arrayAccordion;
  }

  ngAfterViewInit(): void {
    this.searchCtrl();
  }

  searchCtrl(): any {
    const search = this.searchForm.get("content").value;
    const type = this.searchForm.get("type").value;
    this.search = search;

    if (this.arrayAccordionUnsorted) {
      if (type === "ALL" && search.length === 0) {
        return (this.filteredArray = []);
      }

      if (type !== "ALL") {
        this.filteredArray = this.arrayAccordionUnsorted
          .filter((item) => {
            return (
              this.helperService
                .normalizeWord(item.alertMessage)
                .indexOf(this.helperService.normalizeWord(search)) > -1
            );
          })
          .filter((item) => {
            return item.readStatus === this.searchForm.get("type").value;
          });
      } else {
        this.filteredArray = this.arrayAccordionUnsorted.filter((item) => {
          return (
            this.helperService
              .normalizeWord(item.alertMessage)
              .indexOf(this.helperService.normalizeWord(search)) > -1
          );
        });
      }
    }
  }

  setAlert(alert: AlertDTO): void {
    this.selectedItem.emit(alert);
    window.document.getElementById(alert.id.toString()).style.background =
      "#00ff00";
    this.alertsService
      .getUnreadAlerts$()
      .pipe(take(1))
      .subscribe((alerts) => {
        const currentAlert = alerts.reduce(function (
          arrayReduce,
          alertCurrent,
          index
        ) {
          if (alertCurrent.id === alert.id) {
            delete alerts[index];
            arrayReduce.push(index);
          }
          return arrayReduce;
        },
        []);
        if (currentAlert.length > 0) {
          this.alertsService.setUnreadAlerts$(alerts);
          this.alertsService.setRead(alert.id).subscribe((res) => res);
          this.alertsService
            .getNumberUnreadAlerts$()
            .pipe(take(1))
            .subscribe((numberAlerts) => {
              this.alertsService.setNumberUnreadAlerts$(numberAlerts - 1);
            });
        }
      });
  }

  alertReadStatus(event) {
    let arrayAccordion: AlertRange = {} as AlertRange;
    let arrayAccordionUnsorted = new Array<AlertDTO>();
    if (event.value === "all") {
      this.arrayAccordionUnsorted = this.arrayAccordionUnsortedUnFiltered;
      arrayAccordion = this.arrayAccordionUnfiltered;
    } else if (event.value === "read") {
      arrayAccordion.today = this.arrayAccordionUnfiltered.today.filter(
        (alert) => alert.readStatus === "READ"
      );
      arrayAccordion.yesterday = this.arrayAccordionUnfiltered.yesterday.filter(
        (alert) => alert.readStatus === "READ"
      );
      arrayAccordion.week = this.arrayAccordionUnfiltered.week.filter(
        (alert) => alert.readStatus === "READ"
      );
      arrayAccordion.older = this.arrayAccordionUnfiltered.older.filter(
        (alert) => alert.readStatus === "READ"
      );
      arrayAccordionUnsorted = this.arrayAccordionUnsortedUnFiltered.filter(
        (alert) => alert.readStatus === "READ"
      );
    } else if (event.value === "unread") {
      arrayAccordion.today = this.arrayAccordionUnfiltered.today.filter(
        (alert) => alert.readStatus === "UNREAD"
      );
      arrayAccordion.yesterday = this.arrayAccordionUnfiltered.yesterday.filter(
        (alert) => alert.readStatus === "UNREAD"
      );
      arrayAccordion.week = this.arrayAccordionUnfiltered.week.filter(
        (alert) => alert.readStatus === "UNREAD"
      );
      arrayAccordion.older = this.arrayAccordionUnfiltered.older.filter(
        (alert) => alert.readStatus === "UNREAD"
      );
      arrayAccordionUnsorted = this.arrayAccordionUnsortedUnFiltered.filter(
        (alert) => alert.readStatus === "UNREAD"
      );
    }
    this.arrayAccordion = arrayAccordion;
    this.arrayAccordionUnsorted = arrayAccordionUnsorted;
    this.searchCtrl();
  }
}
